export const PAYMENT_METHODS_LOAD = "paymentMethods.load";
export const PAYMENT_METHODS_CLEAR = "paymentMethods.clear";
export const PAYMENT_METHODS_ERROR = "paymentMethods.error";
export const SET_SELECTED_PAYMENT_METHOD =
  "paymentMethods.SET_SELECTED_PAYMENT_METHOD";

export const PAYMENT_TYPES = Object.freeze({
  ACH_BULK: "ACH_BULK",
  MAILCHECK_BULK: "MAILCHECK_BULK",
  PAYPAL_ACCOUNT_BULK: "PAYPAL_ACCOUNT_BULK",
  PAYPALEXPRESS: "PAYPALEXPRESS",
});
